
import accountSwitcher from '@/api/accountSwitcher';
import { mapState } from 'vuex';

export default {
  name: 'NavigationAccountSwitcher',

  props: {
    expanded: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState('user', ['currentAccount']),
  },

  data: () => {
    return {
      logins: [],
    };
  },

  created() {
    this.grabLogins();
  },

  methods: {
    grabLogins() {
      accountSwitcher.getLogins().then((rsp) => {
        this.logins = rsp.data.data;
      });
    },

    switchTo(login) {
      accountSwitcher.switchTo({ account_uuid: login.account.uuid }).then((rsp) => {
        location.reload();
      });
    },

    getRoles(login) {
      if (login.account.type === 'client') {
        return 'Client';
      }

      const roleNames = login.account.roles ? Object.values(login.account.roles) : [];
      if (roleNames.length) {
        // RBAC role names are typed by the firm, so show them exactly as entered -
        // sentence casing flattened names like "Role 1 ABC DeF" to "Role 1 abc def".
        // Matches how role names are already rendered elsewhere, e.g. ClientListItem.
        return roleNames.join(', ');
      }

      // Fall back to the legacy single role when no RBAC roles are assigned.
      let formattedRole = this.$helpers.sentencify(login.account.role ?? '');
      if (login.user_type === 'enterprise') {
        formattedRole = `Enterprise ${formattedRole}`.trim();
      }

      return formattedRole;
    },
  },
};
